import { getToken } from './localstorage';

// export const BaseURLDev = 'http://199.97.20.150:1212/api/v01';
// export const BaseURLDev = 'https://apiret-bappenda.ntbprov.go.id/api/v01';
export const BaseURLDev = process.env.REACT_APP_BASE_URL;

export const headers = {
   'content-type': 'application/json',
   'Authorization': `Bearer ${getToken()}`
}


// WEBPACK FOOTER //
// ./src/_utils/config.js